import { Evaluation } from "../types/Scorecard";
import { getData, postData } from "./apiService";

/**
 * Create a new judge evaluation.
 * @param evaluation - The evaluation details to create.
 * @returns Promise<void>
 */
export const createEvaluation = async (evaluation: Evaluation): Promise<void> => {
  try {
    await postData(`/evaluations`, evaluation); // API call to create an evaluation
  } catch (error) {
    console.error("Failed to create evaluation:", error);
  }
};

/**
 * Get all evaluations for an event, sorted by creation time.
 * @param event_id - The ID of the event.
 * @returns Promise<EvaluationDetails[]>
 */
export const getEvaluationsByEventId = async (event_id: string): Promise<Evaluation[]> => {
  try {
    const response = await getData(`/events/${event_id}/evaluations`, {}); // API call to fetch evaluations for an event
    return response.data as Evaluation[];
  } catch (error) {
    console.error("Failed to fetch evaluations by event ID:", error);
    return []; // Return an empty array in case of an error
  }
};

/**
 * Get a specific evaluation by its judge score ID.
 * @param judge_score_id - The ID of the judge's score.
 * @returns Promise<EvaluationDetails | null>
 */
export const getEvaluationByJudgeId = async (judge_score_id: string): Promise<Evaluation | null> => {
  try {
    const response = await getData(`/evaluations/judge/${judge_score_id}`, {}); // API call to fetch a single evaluation by judge score ID
    return response.data as Evaluation;
  } catch (error) {
    console.error("Failed to fetch evaluation by judge score ID:", error);
    return null; // Return null in case of an error
  }
};

/**
 * Get all evaluations for a specific registrant, sorted by creation time.
 * @param registrant_id - The ID of the registrant.
 * @returns Promise<EvaluationDetails[]>
 */
export const getEvaluationsByRegistrantId = async (registrant_id: string): Promise<Evaluation[]> => {
  try {
    const response = await getData(`/registrants/${registrant_id}/evaluations`, {}); // API call to fetch evaluations for a registrant
    return response.data as Evaluation[];
  } catch (error) {
    console.error("Failed to fetch evaluations by registrant ID:", error);
    return []; // Return an empty array in case of an error
  }
};
